import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-38ac76d8")
const _hoisted_1 = { class: "height-full width-full bg" }
const _hoisted_2 = { class: "justify-center content d-flex" }
const _hoisted_3 = { class: "table width-full card pa-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "px-2" }
const _hoisted_6 = { class: "px-2" }
const _hoisted_7 = {
  key: 0,
  class: "px-2"
}
const _hoisted_8 = ["onChange"]
const _hoisted_9 = ["value", "selected"]
const _hoisted_10 = {
  key: 1,
  class: "px-2"
}
const _hoisted_11 = { class: "px-2" }
const _hoisted_12 = { class: "px-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("mdi-calendar")
const _hoisted_14 = { class: "justify-end px-2 d-flex align-center" }
const _hoisted_15 = { class: "button" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("mdi-download")
_popScopeId()

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { AxiosInstance } from 'axios'
import AppBar from '@/components/Automations/AppBar.vue'
import DuplicateAutomationDialog from '@/components/Automations/Dialog/DuplicateAutomationDialog.vue'
import DeleteAutomationDialog from '@/components/Automations/Dialog/DeleteAutomationDialog.vue'
import NewVersionAutomationDialog from '@/components/Automations/Dialog/NewVersionAutomationDialog.vue'
import DeactivateAutomationDialog from '@/components/Automations/Dialog/DeactivateAutomationDialog.vue'
import ActivateAutomationDialog from '@/components/Automations/Dialog/ActivateAutomationDialog.vue'
import EditAutomationDialog from '@/components/Automations/Dialog/EditAutomationDialog.vue'
import BaseSnackbar from '@/components/BaseSnackbar.vue'
import { readableTime } from '@/lib/helper'
import createAuth0APIClient from '@/clients/hoppermation'
import { IAutomation, IChannel } from '@/interfaces/hoppermation'
import AutomationState from '@/lib/enums/AutomationState'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'
import ImportDialog from '@/components/Automations/Dialog/ImportDialog.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const { t } = useI18n()

const hoppermationApiClient = ref({} as AxiosInstance)
const channels = ref([] as IChannel[])
const automations = ref([] as IAutomation[])
const headers = [
  { text: t('table.name'), value: 'name' },
  { text: t('table.channel'), value: 'channel' },
  { text: t('table.version'), value: 'version' },
  { text: t('table.state'), value: 'state' },
  { text: t('table.updatedAt'), value: 'updatedAt' }
]

onMounted(async () => {
  hoppermationApiClient.value = await createAuth0APIClient()
  getChannels()
  getAutomations()
})

const exportAutomation = async (automation: IAutomation) => {
  const { data, headers } = await hoppermationApiClient.value.get(`/automations/${automation.id}/export`)
  const blob = new Blob([JSON.stringify(data)], { type: headers['content-type'] })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `automation-${automation.name}_${automation.id}.json`
  link.click()
}

// TODO vuetify 3 table, remove as soon as expandable table is available
const getNumbers = (start: number, stop: number): number[] => {
  return new Array(stop - start).fill(start).map((n, i) => n + i)
}

const changeSelectedVersion = async ($event: Event, id: string, latestVersion: number): Promise<void> => {
  const target = $event.target as HTMLSelectElement
  const number = target.value

  try {
    const { data: versions } = await hoppermationApiClient.value.get(`/automations/${id}/versions`)

    const selectedVersion = versions.find((item: IAutomation) => item.version.number.toString() === number)

    selectedVersion.latestVersion = latestVersion
    const objIndex = automations.value.findIndex((obj: IAutomation) => obj.id === id)
    automations.value[objIndex] = selectedVersion
  } catch (error) {
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.automation.changeVersion.error' })
  }
}

const openEditor = ($event: Event, automationId: string): void => {
  const target = $event.target as HTMLElement
  // TODO vuetify 3 table, remove check for select as soon as available
  if (target.nodeName !== 'SELECT') {
    router.push({
      name: 'Editor',
      params: { id: automationId }
    })
  }
}

const channelNameById = (channelId: string): string => {
  const channel = channels.value.find((channel: IChannel) => channel.id === channelId) || { name: '' }
  return channel.name
}

const getChannels = async (): Promise<void> => {
  try {
    const res = await hoppermationApiClient.value.get('/channels')
    channels.value = res.data
  } catch (error) {
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.channels.fetch.error' })
  }
}

const getAutomations = async (): Promise<void> => {
  try {
    const { data } = await hoppermationApiClient.value.get('/automations')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.forEach((item: any) => (item.latestVersion = item.version.number))
    automations.value = data
  } catch (error) {
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.automations.fetch.error' })
  }
}

const isActive = (status: string): boolean => {
  return status === AutomationState.ACTIVE
}
const isArchived = (status: string): boolean => {
  return status === AutomationState.ARCHIVED
}
const isDraft = (status: string): boolean => {
  return status === AutomationState.DRAFT
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (channels.value)
      ? (_openBlock(), _createBlock(AppBar, {
          key: 0,
          channels: channels.value
        }, null, 8, ["channels"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tr", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (item) => {
            return _createElementVNode("th", {
              class: "px-2 text-left",
              key: item.value
            }, _toDisplayString(item.text), 1)
          }), 64))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(automations.value, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "py-5 width-full tableRow",
            key: item.id,
            onClick: ($event: any) => (!isArchived(item.status) ? openEditor($event, item.id) : () => {})
          }, [
            _createElementVNode("td", _hoisted_5, _toDisplayString(item.name), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(channelNameById(item.channelId)), 1),
            (item.latestVersion > 1)
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _createElementVNode("select", {
                    class: "px-4 width-full select",
                    onChange: ($event: any) => (changeSelectedVersion($event, item.id, item.latestVersion))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNumbers(1, item.latestVersion + 1), (n) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: n,
                        value: n,
                        selected: n === item.version.number
                      }, [
                        _createElementVNode("span", null, _toDisplayString(n) + " ⬇️", 1)
                      ], 8, _hoisted_9))
                    }), 128))
                  ], 40, _hoisted_8)
                ]))
              : _createCommentVNode("", true),
            (item.latestVersion <= 1)
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(item.version.number), 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_v_chip, {
                class: _normalizeClass(["justify-center width-full chip d-flex font-weight-black", isActive(item.status) ? 'chip-active' : isArchived(item.status) ? 'chip-archived' : ''])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`automation.status.${item.status}`)), 1)
                ]),
                _: 2
              }, 1032, ["class"])
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_unref(readableTime)(item.updatedAt)), 1)
            ]),
            _createElementVNode("td", _hoisted_14, [
              (isDraft(item.status))
                ? (_openBlock(), _createBlock(ActivateAutomationDialog, {
                    key: 0,
                    automation: item,
                    submit: getAutomations
                  }, null, 8, ["automation"]))
                : _createCommentVNode("", true),
              _createVNode(NewVersionAutomationDialog, {
                automation: item,
                submit: getAutomations
              }, null, 8, ["automation"]),
              _createVNode(DuplicateAutomationDialog, {
                automation: item,
                channels: channels.value,
                submit: getAutomations
              }, null, 8, ["automation", "channels"]),
              _createVNode(EditAutomationDialog, {
                automation: item,
                channels: channels.value,
                submit: getAutomations
              }, null, 8, ["automation", "channels"]),
              (!isActive(item.status))
                ? (_openBlock(), _createBlock(DeleteAutomationDialog, {
                    key: 1,
                    automation: item,
                    submit: getAutomations
                  }, null, 8, ["automation"]))
                : _createCommentVNode("", true),
              (isActive(item.status))
                ? (_openBlock(), _createBlock(DeactivateAutomationDialog, {
                    key: 2,
                    automation: item,
                    submit: getAutomations
                  }, null, 8, ["automation"]))
                : _createCommentVNode("", true),
              (isDraft(item.status))
                ? (_openBlock(), _createBlock(ImportDialog, {
                    key: 3,
                    automation: item
                  }, null, 8, ["automation"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_icon, {
                  size: "small",
                  class: "mr-5",
                  onClick: _withModifiers(() => exportAutomation(item), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createVNode(BaseSnackbar)
  ]))
}
}

})